import { CommonModule } from "@angular/common";
import { Component, computed, input, output } from "@angular/core";
import {
    CenterChildDto,
    TicketDto,
} from "@malirang/api-client";
import { ContactPipe, Icon } from "@malirang/front-share";
import { DocumentBackButton } from "../../components/document-back-button/document-back-button";

@Component({
    selector: "app-document-child-info",
    templateUrl: "./document-child-info.html",
    styleUrls: ["./document-child-info.css"],
    imports: [CommonModule, DocumentBackButton, Icon, ContactPipe],
})
export class DocumentChildInfo {
    back = output<void>();
    currentChild = input.required<CenterChildDto>();
    tickets = computed<TicketDto[]>(
        () =>
            this.currentChild()?.enrollments?.flatMap((enrollment) => {
                const teacher = enrollment.teacher;

                return (
                    enrollment.tickets.map((ticket) => ({
                        ...ticket,
                        enrollment: { ...enrollment, teacher },
                    })) || []
                );
            }) || [],
    );
}
